import getSymbolFromCurrency from 'currency-symbol-map';

class StringsUtil {
  public symbolByCurrency = (currency: string): string => {
    return getSymbolFromCurrency(currency) ?? '$';
  };
}

export const stringsUtil = new StringsUtil();
